import { LANG_STORAGE_KEY, Language, LANGUAGES } from '@/shared/config';

export const languageInstall = (): Language => {
  const storageLang = localStorage.getItem(LANG_STORAGE_KEY) as Language;

  if (storageLang && LANGUAGES.includes(storageLang)) {
    return storageLang;
  }

  return Language.Russian;
};
